// Email validation - strict format validation
export const validateEmail = (email) => {
  // RFC 5322 compliant email regex (simplified)
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.trim());
};

// Phone number validation - must be exactly 10 digits
export const validatePhone = (phone) => {
  // Remove all non-digit characters for validation
  const digitsOnly = phone.replace(/\D/g, '');
  // Phone must be exactly 10 digits
  return digitsOnly.length === 10;
};

// Format phone number as XXX-XXX-XXXX
export const formatPhoneNumber = (phone) => {
  const digitsOnly = phone.replace(/\D/g, '');
  if (digitsOnly.length <= 3) return digitsOnly;
  if (digitsOnly.length <= 6) return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
  return `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6, 10)}`;
};

// Common country codes
export const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '🇺🇸' },
  { code: '+44', country: 'UK', flag: '🇬🇧' },
  { code: '+91', country: 'India', flag: '🇮🇳' },
  { code: '+86', country: 'China', flag: '🇨🇳' },
  { code: '+81', country: 'Japan', flag: '🇯🇵' },
  { code: '+49', country: 'Germany', flag: '🇩🇪' },
  { code: '+33', country: 'France', flag: '🇫🇷' },
  { code: '+39', country: 'Italy', flag: '🇮🇹' },
  { code: '+61', country: 'Australia', flag: '🇦🇺' },
  { code: '+971', country: 'UAE', flag: '🇦🇪' },
  { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+7', country: 'Russia', flag: '🇷🇺' },
  { code: '+82', country: 'South Korea', flag: '🇰🇷' },
  { code: '+65', country: 'Singapore', flag: '🇸🇬' },
  { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
];

// Get validation error messages
export const getEmailError = (email) => {
  if (!email) return 'Email address is required';
  if (!validateEmail(email)) return 'Please enter a valid email address (e.g., user@example.com)';
  return '';
};

export const getPhoneError = (phone, countryCode = '+1') => {
  if (!phone) return 'Phone number is required';
  const digitsOnly = phone.replace(/\D/g, '');
  if (digitsOnly.length === 0) return 'Phone number is required';
  if (digitsOnly.length < 10) return `Phone number must be 10 digits (e.g., ${countryCode} 123-456-7890)`;
  if (digitsOnly.length > 10) return 'Phone number must be exactly 10 digits';
  if (!validatePhone(phone)) return `Please enter a valid phone number (e.g., ${countryCode} 123-456-7890)`;
  return '';
};
